import apiClient from './client.js';
const base = (wsId) => `/workspaces/${wsId}/automation`;
export const getCatalog = (wsId) => apiClient.get(`${base(wsId)}/catalog`).then(r => r.data);
export const list = (wsId) => apiClient.get(base(wsId)).then(r => r.data);
export const create = (wsId, dto) => apiClient.post(base(wsId), dto).then(r => r.data);
export const update = (wsId, id, dto) => apiClient.patch(`${base(wsId)}/${id}`, dto).then(r => r.data);
export const remove = (wsId, id) => apiClient.delete(`${base(wsId)}/${id}`).then(r => r.data);
export const toggle = (wsId, id, isActive) => apiClient.patch(`${base(wsId)}/${id}/toggle`, { isActive }).then(r => r.data);
export const getLogs = (wsId, id) => apiClient.get(`${base(wsId)}/${id}/logs`).then(r => r.data);
export const execute = (wsId, id, data) => apiClient.post(`${base(wsId)}/${id}/execute`, data).then(r => r.data);
